import { InjectionKey, Ref } from "vue";

export const IsOpen: InjectionKey<Ref<boolean>> = Symbol("IsOpen");
